export function keyDetails() {
    const stickyEl = document.querySelector('.site-page__events-right-section-button');
    const headerHeight = document.querySelector('.site-header').offsetHeight;
    const buffer = 10; 

    let lastState = false;

    function handleScroll() {
    const rect = stickyEl.getBoundingClientRect();
    const triggerPoint = headerHeight + 10;
    const isNowActive = rect.top <= (triggerPoint + buffer);

    if (isNowActive !== lastState) {
        stickyEl.classList.toggle('site-page__events-right-section-button--active', isNowActive);
        lastState = isNowActive;
    }
    }


    window.addEventListener('scroll', handleScroll);
}